import { connect } from "react-redux";
import { Action, Dispatch } from "redux";

import {
  applicantExamGetAction,
  applicantExamSubmitAction,
  applicantExamOpenAction,
  applicantUpdateFormAction,
  challengeStartAction,
  challengeResetAction,
  challengeSaveAction,
  challengeSwitchLangAction,
  challengeUpdateVarsAction,
  challengeContextAction,
  challengeContextRemoveAction,
  applicantNotificationRemoveAction,
  editorHasUnsavedSetAction,
  editorReadyAction,
  tutorialExamGetAction,
  presignedAction,
  updateAppealComment,
  healthCheckAction,
  challengeSwitchTakenByAction,
  applicantSessionExtendAction,
  applicantSwitchTabEventAction,
  applicantExamFaceVerifiedAction,
  challengeSwitchFrontendTemplateAction,
  editorReloadAction,
} from "@actions";

import { RootState } from "@reducers";

import { useFeatureFlags } from "@shared/hooks/query";
import { isValidApplicantURL } from "@shared/services/url";
import { withCustomHook } from "@shared/services/withCustomHook";

import Editor, { EditorProps } from "./Editor";

const wrapper = withCustomHook<EditorProps>(({}) => {
  const { data } = useFeatureFlags();

  return {
    isWebcamEnabled: data?.webcamEnabled,
  };
})(Editor);

const mapStateToProps = (state: RootState) => ({
  authenticated: state.applicant.auth.authenticated,
  loading:
    state.ajax.submitting &&
    !state.applicant.challengeEditorContext.challengeSubmitting,
  sessionDuplicated: state.applicant.sessionDuplicated,
  keyEventSessionDuplicated: state.applicant.keyEventSessionDuplicated,
  exam: state.applicant.exam,
  tutorial:
    (window && window.location.pathname.startsWith("/tutorial")) || false,
  challengeContext: state.applicant.challengeContext,
  challengeEditorContext: state.applicant.challengeEditorContext,
  error:
    state.applicant.error || !isValidApplicantURL(window.location.pathname),
  challengeSourceFiles: state.applicant.challengeSourceFiles,
  health: state.healthCheck.health,
  isUpdatingAppealComment: state.applicant.isUpdatingAppealComment,
  isUpdateAppealCommentSuccess: state.applicant.isUpdateAppealCommentSuccess,
  isUpdateAppealCommentError: state.applicant.isUpdateAppealCommentError,
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  updateFormAndOpenExam: (payload: {}) => {
    dispatch(applicantExamOpenAction.request(payload));
  },
  updateFaceLivenessSuccess: () => {
    dispatch(applicantExamFaceVerifiedAction.success());
  },
  updateForm: (payload: {}) => {
    dispatch(applicantUpdateFormAction.request(payload));
  },
  getExam: () => {
    dispatch(applicantExamGetAction.request());
  },
  submitExam: () => {
    dispatch(applicantExamSubmitAction.request());
  },
  getChallengeContext: (params: {}) => {
    dispatch(challengeContextAction.request({}, params));
  },
  removeChallengeContext: () => {
    dispatch(challengeContextRemoveAction.request());
  },
  startChallenge: (payload: {}) => {
    dispatch(challengeStartAction.request(payload));
  },
  resetChallenge: (params: {}) => {
    dispatch(challengeResetAction.request({}, params));
  },
  saveChallenge: (payload: {}, params?: {}) => {
    dispatch(challengeSaveAction.request(payload, params));
  },
  switchLanguage: (payload: {}, params: {}) => {
    dispatch(challengeSwitchLangAction.request(payload, params));
  },
  switchFrontendTemplate: (payload: {}, params: {}) => {
    dispatch(challengeSwitchFrontendTemplateAction.request(payload, params));
  },
  updateEnvVars: (payload: {}, params: {}) => {
    dispatch(challengeUpdateVarsAction.request(payload, params));
  },
  removeNotification: (payload: {}) => {
    dispatch(applicantNotificationRemoveAction.request(payload));
  },
  setEditorHasUnsaved: (payload: {}) => {
    dispatch(editorHasUnsavedSetAction.request(payload));
  },
  setEditorReady: () => {
    dispatch(editorReadyAction.request());
  },
  setEditorReload: () => {
    dispatch(editorReloadAction.request());
  },
  getTutorialExam: (payload: {}) => {
    dispatch(tutorialExamGetAction.request(payload));
  },
  getPresigned: (payload: {}, params: {}) => {
    dispatch(presignedAction.request(payload, params));
  },
  updateAppealComment: (payload: {}, params: {}) => {
    dispatch(updateAppealComment.request(payload, params));
  },
  healthCheck: () => {
    dispatch(healthCheckAction.request());
  },
  switchTakenBy: (payload: {}, params: {}) => {
    dispatch(challengeSwitchTakenByAction.request(payload, params));
  },
  extendSession: () => {
    dispatch(applicantSessionExtendAction.request());
  },
  createSwitchTabEvent: (payload: boolean) => {
    dispatch(applicantSwitchTabEventAction.request(payload));
  },
});

/**
 * Wrapped component
 */
const wrappedComponent = connect(mapStateToProps, mapDispatchToProps)(wrapper);

export default wrappedComponent;
